module.exports = __webpack_public_path__ + "media/images/lightbox/next@2x-41873d8ae09b0a9f09ec82b31e7f365f.png";